var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.header_show)?_c('cheader',{attrs:{"pagefor":_vm.pagefor}}):_vm._e(),_c('router-view',{on:{"header":_vm.header,"footer":_vm.footer}}),(_vm.footer_show)?_c('cfooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }